// extracted by mini-css-extract-plugin
export var createdDate = "_j9-1";
export var divider = "_j9-2";
export var headerDivider = "_j9-3";
export var messagesCard = "_j9-0";
export var messagesContainer = "_j9-6";
export var messagesContainerWrapper = "_j9-4";
export var showLeftPanelButton = "_j9-8";
export var topButtons = "_j9-7";
export var withPadding = "_j9-5";